module.exports = __webpack_public_path__ + "img/1F914.4dd0289e.svg";